import styled from "styled-components";

/**
 * Estilo do componente AdBanner.
 *
 * Configura estilização dinâmica com base nas props fornecidas.
 */
export const Container = styled.div`
  padding-top: ${({ theme }) => theme.spacing(12)};
  width: -webkit-fill-available;
  justify-content: center;
  align-items: center;
  display: flex;
`;
